import { render } from "./HeaderNew.vue?vue&type=template&id=5e759d72&scoped=true&ts=true"
import script from "./HeaderNew.vue?vue&type=script&lang=ts"
export * from "./HeaderNew.vue?vue&type=script&lang=ts"

import "./HeaderNew.vue?vue&type=style&index=0&id=5e759d72&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e759d72"]])

export default __exports__